import { useCallback } from "react";
import { updateUserPreference } from "../../api";
import { useAppContext } from "../../api/AppContext";

export const usePreferredLanguagePersistence = () => {
  const { setUser } = useAppContext();

  return useCallback(
    async (preferredLanguage) => {
      const result = await updateUserPreference({ preferredLanguage });

      setUser((previousUser) => ({
        ...previousUser,
        preferredLanguage: result.preferredLanguage,
        validLanguages: result.validLanguages || previousUser?.validLanguages,
      }));
    },
    [setUser]
  );
};
